import client from './client';

export default (function concernCategoriesService() {
  let service;

  if (!service) {
    service = client.service('concernCategories');
  }

  return service;
}());
